module.exports = __webpack_public_path__ + "img/logo-the-lobby-fizeaustraat.9f62a870a64053c11d56a0356256ee27.svg";